import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Zap, Menu, X } from "lucide-react";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center gap-2 group ${className}`} data-testid="brand-logo">
    <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center group-hover:scale-105 transition-transform">
      <Zap className="w-5 h-5 text-background" fill="currentColor" strokeWidth={2.5} />
    </div>
    <span className="font-heading font-extrabold text-xl tracking-tight">Clout<span className="text-primary">Rise</span></span>
  </Link>
);

const Navbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const links = [
    { label: "How it works", href: "#how" },
    { label: "Features", href: "#features" },
    { label: "Pricing", href: "#pricing" },
    { label: "Reviews", href: "#reviews" },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-background/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors" data-testid={`nav-${l.href.slice(1)}`}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Button onClick={() => navigate(user.role === "admin" ? "/admin" : "/dashboard")} className="rounded-full bg-primary text-background font-bold hover:bg-primary/90 hover:scale-105 transition-transform" data-testid="nav-dashboard-btn">
              Dashboard
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} className="text-foreground hover:bg-white/5" data-testid="nav-login-btn">Log in</Button>
              <Button onClick={() => navigate("/register")} className="rounded-full bg-primary text-background font-bold hover:bg-primary/90 hover:scale-105 transition-transform" data-testid="nav-signup-btn">Start Growing</Button>
            </>
          )}
        </div>
        <button className="md:hidden text-foreground" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-background/95 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-muted-foreground">{l.label}</a>
          ))}
          {user ? (
            <Button onClick={() => navigate(user.role === "admin" ? "/admin" : "/dashboard")} className="rounded-full bg-primary text-background font-bold">Dashboard</Button>
          ) : (
            <>
              <Button variant="outline" onClick={() => navigate("/login")} className="rounded-full">Log in</Button>
              <Button onClick={() => navigate("/register")} className="rounded-full bg-primary text-background font-bold">Start Growing</Button>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
